import type { Context } from 'react'
import { createContext } from 'react'
import { SIDE_MENU_INITIAL_VALUES } from './constants'
import type { SideMenuContextT } from './types'

const SideMenuContext: Context<SideMenuContextT> = createContext(SIDE_MENU_INITIAL_VALUES as SideMenuContextT)

export default SideMenuContext
